module.exports = __webpack_public_path__ + "static/img/banner1.1d6e16c7.jpg";